import * as React from "react";
function SvgChevronDown(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#chevron-down_svg__clip0_2_3025)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.293 16.707l-8-8 1.414-1.414L12 14.586l7.293-7.293 1.414 1.414-8 8a1 1 0 01-1.414 0z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="chevron-down_svg__clip0_2_3025">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgChevronDown);
export default ForwardRef;
